import { isRequestError, isUserFacingRequestError } from "@packages/sdk";

export type SkipError = { raisedAt: number } & (
  | { type: "dailyLimit" }
  | { type: "hourlyLimit" }
  | { type: "message"; message: string }
);

const SKIP_LIMIT_HOURLY_CODE = 11000;
const SKIP_LIMIT_DAILY_CODE = 11001;

export const toSkipError = (error: unknown): SkipError | null => {
  const raisedAt = Date.now();

  if (isRequestError(error)) {
    if (error.code === SKIP_LIMIT_DAILY_CODE)
      return { raisedAt, type: "dailyLimit" };
    if (error.code === SKIP_LIMIT_HOURLY_CODE)
      return { raisedAt, type: "hourlyLimit" };
  }

  return isUserFacingRequestError(error)
    ? { raisedAt, type: "message", message: error.message }
    : null;
};
